const ko = {
  // 로딩
  loading: '로딩 중...',
  // 로그인
  welcome: '환영합니다',
  home: '홈',
  login: '로그인',
  email: '이메일',
  password: '비밀번호',
  signUp: '회원가입',
  findPassword: '비밀번호 찾기',
  thisLoginIsForPartnerOnlyToPlayer:
    '현재 페이지는 파트너 전용 로그인 페이지입니다.\n플레이어는 PingPong 앱을 통해 로그인해 주세요.',
  thisLoginIsForPartnerOnly: '현재 페이지는 파트너 전용 로그인 페이지입니다.',
  enterTheEmailToBeUsedAsYourId: '아이디로 사용할 이메일 주소 입력',
  pleaseEnterAcombinationOfInput: '영문, 숫자, 특수문자의 조합 8자리 이상 입력',
  pleaseEnterAcombination:
    '* 영문, 숫자, 특수문자 중 2종의 조합으로 8자리 이상 입력하세요.',
  pleaseEnterTheEmail: '* 이메일을 입력하세요.',
  pleaseEnterAvalidEmailAddress: '* 올바른 이메일을 입력하세요.',
  theInputValueIsNotValid: '입력값이 올바르지 않습니다.',
  pleaseEnterYourPassword: '* 비밀번호를 입력하세요.',
  pleaseEnterYourEmail: '* 이메일을 입력하세요.',
  invalidEmailOrPassword:
    '아이디 (이메일 계정) 또는 비밀번호가 잘못되었습니다.\n아이디 또는 비밀번호를 정확히 입력해주세요.',
  // 페이지네이션
  prev: '이전',
  next: '다음',
  // 네이게이션(사이드바)
  failedLoadPartnerProfile: '파트너 프로필을 불러오는 데 실패했습니다.',
  // 주문 상태
  registeredStatus: '등록됨',
  accept: '접수승인',
  acceptApproved: '접수승인됨',
  acceptPending: '접수대기',
  acceptRejected: '접수거절',
  canceled: '취소됨',
  designConfirmRequested: '디자인 컨펌 요청',
  closed: '종료',
  workProcessing: '작업중',
  // 검색
  moreSearchResults: '결과 내 검색',
  // 주문 목록 페이지, 완료된 주문 목록 페이지
  searchByOrderNameClinicNameOrPatientName:
    '오더 번호, 치과명, 환자명으로 검색',
  completionDate: '완료일',
  close: '닫기',
  more: '열기',
  failedToChangeOrderStatus: '주문 상태 변경에 실패했습니다.',
  failedToLoadOrderList: '주문 목록을 불러오는 데 실패했습니다.',
  failedToLoadCompletedOrderList:
    '완료된 주문 목록을 불러오는 데 실패했습니다.',
  // 주문 상세
  orderDetailAndComment: '주문상세 및 코멘트',
  fileUpload: '파일 업로드',
  history: '주문 이력',
  youCanUploadMaximumOf5ItemsPerCategory: '최대항목당 5개까지 업로드 가능',
  thereAreNoAttachments: '첨부된 파일이 없습니다.',
  thereAreNoProjectFilesUploaded: '업로드된 프로젝트 파일이 없습니다.',
  thereAreNoStlFilesUploaded: '업로드된 STL 파일이 없습니다.',
  thereAreNoEtcFilesUploaded: '업로드된 ETC 파일이 없습니다.',
  thereIsNoOrderHistory: '주문 이력이 없습니다.',
  disabled: '비활성화',
  failedToUploadFile: '파일 업로드에 실패했습니다.',
  failedToDeleteFile: '파일 삭제에 실패했습니다.',
  failedLoadOrderDetail: '주문 상세 정보를 불러오는 데 실패했습니다.',
  downloadAllFiles: '전체 파일 다운로드 하기',
  youCanUploadUpTo10Images: '첨부 파일은 10개 까지 업로드할 수 있습니다.',
  unsupportedFileFormat: '지원하지 않는 파일 형식입니다.',
  fileNameGuide: '파일명 구분 안내',
  playerRevisionUploaded:
    '플레이어 수정본이 업로드되었습니다. 변경 사항을 확인해 주세요.',
  finalConfirmedFilesByThePlayer:
    '플레이어 최종 승인이 완료된 확정 파일입니다.',
  // 주문자 목록
  searchByOrdererIdOrName: '주문자 ID 또는 이름으로 검색',
  officeClinic: '오피스(치과)명',
  failedToLoadOrdererList: '주문자 목록을 불러오는 데 실패했습니다.',
  // partner > support
  qrCodeScan: 'QR 코드 스캔',
  // 404
  thePageIsUnavailable: '페이지를 사용할 수 없습니다',
  thePageYouAreLookingForDoesNotExistOrIsCurrentlyUnavailable:
    '찾으시는 페이지가 존재하지 않거나 현재 사용할 수 없습니다.',
  pleaseCheckTheAddressYouEnteredOnceAgain:
    '입력하신 주소를 다시 한번 확인해주세요.',
  goToHome: '홈으로 이동',
  // navbar
  dashboard: '대시보드',
  orderList: '주문 목록',
  completedOrder: '완료된 주문',
  myPlayer: '나의 플레이어',
  businessProfile: '비즈니스 프로필',
  addProductService: '서비스 등록',
  customerCenter: '고객 센터',
  logout: 'Log out',
  // 메인 페이지
  theR2PlayersFromAllAroundTheWorldAreWaitingForYou:
    '전 세계 R2player들이 당신을 기다리고 있습니다.',
  myReviews: '내가 받은 별',
  ReceivedOrders: '내가 받은 주문',
  yourBusinessProfileHasNotBeenSetUpYet:
    '비즈니스 프로필이 되어 있지 않습니다.\n비즈니스 프로필을 등록하러 가시겠습니까?',
  noRegisteredServices:
    '서비스 등록이 되어 있지 않습니다.\n서비스를 등록하러 가시겠습니까?',
  goTo: '바로가기',
  // 주문 목록 페이지
  orderNo: '주문번호',
  patient: '환자명',
  orderType: '주문종류',
  orderDate: '주문일자',
  dueDate: '완료요청일',
  status: '진행상태',
  orderDetail: '상세보기',
  reject: '거부',
  cancel: '취소',
  reasonForRejection: '거부 사유',
  orders: '건',
  // 주문 상세
  orderOptions: '주문 옵션',
  designDiagnosisFile: '디자인(진단) 파일',
  customerConfirmationFile: '주문자 컨펌 파일',
  attachedFile: '첨부파일',
  workLog: '작업로그',
  onlyFilesAreSupported: '{{type}} 파일만 지원됩니다.',
  fileUploadLimitfileSizeMustBeMbOrLess:
    '파일 업로드 제한\n파일 용량은 {{size}} 이하만 업로드할 수 있습니다.',
  newOrderReceived: '신규주문이 접수 대기 상태입니다.',
  orderReceivedInProgressPartner: '주문이 진행중으로 변경되었습니다.',
  orderWasRejected: '주문을 거부 처리하였습니다.',
  orderCancelled: '주문이 취소되었습니다.',
  fileUploadCompletedSuccessfully: '파일이 정상 업로드 되었습니다.',
  checkUserConfirmationFile: '플레이어 컨펌 파일을 확인해주세요.',
  theDesignDiagnosisFileHasBeenDeleted: '디자인(진단) 파일이 삭제되었습니다.',
  orderCompleted2: '주문이 완료 되었습니다.',
  designDiagnosisFileUploadedSuccessfully:
    '디자인(진단) 파일이 정상 업로드 되었습니다.',
  confirmRevisionFileUploadedSuccessfully:
    '플레이어 컨펌(재작업) 파일을 확인해주세요.',
  // 나의 플레이어
  nation: '국가',
  contact: '연락처',
  address: '주소',
  registration: '최초주문일',
  chat: '채팅열기',
  people: '명',
  comingSoon: '준비중입니다.',
  // 비즈니스 프로필
  accountInfo: '계정 정보',
  profileSettings: '프로필 설정',
  imagesWillBeAppliedIn100x100Size: '이미지는 100*100 사이즈로 적용됩니다.',
  fileFormatsJpegJpgPngBmpMaxSize20mb:
    '파일형식 : JPEG/JPG, PNG, Bmp<br />파일크기: 20mb이하',
  nationality: '국적',
  contactNo: '연락처',
  r2Center: 'R2 센터명',
  r2Planner: 'R2 플래너',
  officeNo: '대표번호',
  businessAddress: '오피스 주소',
  serviceLanguage: '서비스 언어',
  introduction: '비즈니스 소개',
  businessHours: '비즈니스\n시간설정',
  representativeImages: '대표 이미지',
  sun: '일',
  mon: '월',
  tue: '화',
  wed: '수',
  thu: '목',
  fri: '금',
  sat: '토',
  pleaseSetYourReqularBusinessHours:
    '일일 정규 업무 시간을 지정해주세요.\n지정된 시간 동안, 자동으로 [업무 중]으로\n안내 됩니다.',
  pleaseUploadAnImageThatRepresentsYourCenter:
    ' 센터(플래너)를 대표할수 있는 이미지를 업로드 해 주세요.',
  youCanUploadUpTo5Images: '최대 5개의 이미지까지 업로드 가능합니다.',
  fileFormatsJpegJpgPngBmpTiffSize1gb:
    '파일 확장자 : JPEG/JPG, PNG, Bmp, TIFF / 파일크기 : 1GB 이하',
  save: '저장',
  representative: '대표자명',
  youveExceededTheImageUploadLimit:
    '이미지 갯수 초과입니다.\n기존 이미지 삭제후, 업로드 해주세요.',
  // 고객센터
  scanTheQrCodeToChatWithUsOnYourFavoriteMessengerApp:
    'QR코드를 통해서 다양한 메신져 앱으로 상담을 진행하실 수 있습니다.',
  scanTheQRCodeUsingYourPhonesCamera: '핸드폰의 카메라를 통해 스캔을 해주세요',
  tapTheIconOfYourPreferredChatAppAndSendUsYourInquiry:
    '원하는 채팅앱의 아이콘을 클릭하여, 직접 문의하세요.',
  megagenDigitalLibrary: '메가젠 디지털 라이브러리',
  theLatestMegagenImplantLibraryIsAvailable:
    '메가젠 임플란트의 가장 최신 라이브러리를 제공하고 있습니다.\n버튼을 통해서 라이브러리를 다운로드 받을 수 있습니다.',
  // 서비스 등록
  registerTheServicesYouWantToOfferToR2Players:
    'R2player에게 제공할 서비스를 등록하세요.\n서비스를 희망하는 카테고리를 활성화 하시면,\n세부 옵션을 선택 하거나 직접 생성할 수 있습니다.',
  manufacturingDesign: '제작및 디자인',
  youCanRegisterManufacturingAndDesignServicesForCrownBridgeAndR2Guid:
    'Crown&Bridge와 R2 Guide 제작과\n디자인 서비스를 등록하실수 있습니다.',
  youCanSelectCrownBridgeAndR2GuideServices:
    'Crown&Bridge와 R2 Guide 서비스를 선택하실 수 있으며, 디자인\nOnly가 기본으로 적용되어 디자인 및 진단 서비스만 가능합니다.',
  exclusiveCenterServiceRegistration: '전용 센터 서비스 등록',
  theseServicesAreExclusivelyAvailableOnlyAtCertifiedCenters:
    '인증 받은 센터에서만 제공할 수 있는 독점 서비스 항목입니다.\n전용 센터 서비스 등록을 희망하실 경우, R2playground 운영팀에게 문의 해 주세요.',
  registerVariousManufacturingAndDesignServicesSuchAsCrownsInlaysOnlaysAndImplantProsthetics:
    '크라운, 인·온레이, 임플란트 보철물 등 다양한 제작·디자인 서비스를 등록하세요.\n필요하다면 보철 종류나 소재를 ‘추가 옵션’에서 자유롭게 생성, 추가 하실수 있습니다.',
  defaultOptions: '기본 옵션',
  clickTheOptionButtonOnTheRightToActivateIt:
    '오른쪽 옵션 버튼을 클릭하여 활성화 해주세요.',
  allDefaultOptionsCanBeSelectedSimultaneously:
    '기본 제공 옵션은 모두 중복 선택이 가능하나,\n임의로 삭제하거나 수정할 수 없습니다.',
  afterSelectingTheDefaultOptions:
    '기본 제공 옵션을 선택 후, 저장 버튼을 통해 저장을\n해야 서비스가 활성화 됩니다.',
  addService: '옵션 추가',
  ifYouNeedToAddServiceOptions:
    '서비스 옵션 추가가 필요 하신 경우,\n서비스 이름을 입력후 추가 버튼을 눌러 추가하세요.\n(최대 10개)',
  afterAddingServices:
    '서비스 추가 후, 저장 버튼을 통해 저장을 해야\n서비스가 활성화 됩니다.',
  designService: '디자인 서비스',
  theDesignServceProvidesDesignOnlyWithout:
    'Design Service는 보철 제작을 진행하지 않고,\n디자인만 Player에게 제공하는 서비스 입니다.',
  ifYouWouldLikeToOfferProstheticDeisgnService:
    'In lab Player를 위한 보철물 디자인 서비스 제공을\n원하시면 옵션을 "ON" 해주세요.',
  enterTheServiceNameAndClickThe:
    '서비스 이름을 기입후, "+"버튼을 클릭해 주세요.',
  designOnlyDesignServiceOnly: 'Design Only (옵션 선택시 디자인만 제공됩니다)',
  chooseTheServiceToProvideToThePlayer:
    '플레이어에게 제공할 서비스를 기본 제공 옵션에서 선택하거나, 서비스를 추가하여 저장버튼을 눌러주세요.',
  designOnly: 'Design Only',
  oneDayImplantServicesWithR2GateDiagnosis:
    'R2GATE 진단, R2 Guide 또는 R2 Real Navi, Provisional을 통한 ONE-DAY Implant 서비스를 제공합니다.\n여러분의 전문성이 R2player들의 성공을 만듭니다.',
  qvdDigitalDiagnostcServiceForEdentulousCases:
    'QVD - 무치악 케이스를 위한 디지털 진단 서비스\nR2studioQ 데이터를 기반으로 Dental Avatar를 생성하고, 스마일 시뮬레이션을 통해 최적의 VD를 결정합니다.\n제공 서비스: Dental Avatar · Smile Creator · QVD · Stackable Guide · Provisional Prosthesis',
  fromOrthognathicSurgeryToMaxillofacialProsthetics:
    '양악수술에서 악안면 보철까지,\nFaceGIDE는 정밀한 진단과 수술 계획을 기반으로 환자 맞춤형 솔루션을 제작·제공합니다.',
  megAlignerClearAlignerServiceWithImplant:
    'MegAligner - 임플란트·보철 치료와 함께하는 투명 교정 서비스\n심미는 개별 치아의 수복만으로 완성되지 않습니다. MegAligner는 일반 치료와 투명 교정을 병행하여\n아름다운 미소를 완성하고 환자의 만족도를 높여드립니다.',
  // 모달
  confirm: '확인',
  wouldYouLikeToRejectThisOrder: '오더를 거부하시겠습니까?',
  pleaseEnterTheReasonForRejectingTheOrder:
    '주문을 거부한 사유를 작성해주세요.',
  done: '입력 완료',
  failedToconnectTotheServerPleaseTryAgainLater:
    '서버 연결에 실패하였습니다.\n잠시후, 다시 시도해 주세요.',
  // 중복되는 다국어
  pending: '접수 대기',
  pending2: '접수대기',
  inProgress: '진행중',
  inProgress2: '진행',
  completed: '주문 완료',
  completed2: '완료',
  clinic: '치과명',
  clinic2: '오피스 (치과)명',
  name: 'R2 플레이어 명',
  name2: '성명',
  id: '회원ID',
  id2: '아이디',
  modify: '수정',
  modify2: '편집',
};

export default ko;
